<section class=" d-flex align-items-center justify-content-center pt-5 pl-4 pr-4">
  <mat-card class="mat-elevation-z4 login-section">
    <form [formGroup]="loginForm" (ngSubmit)="userLogin(loginForm.value)">
      <h1 class="mat-headline">Login</h1>
      <p class="mb-3">Sign in to your account</p>

      <mat-form-field appearance="outline" class="w-100 mb-2">
        <mat-label>Mobile/Email</mat-label>
        <input matInput type="text" formControlName="mobile" placeholder="Mobile/Email">
        <mat-error>Mobile or Email is Required!</mat-error>
      </mat-form-field>
      
      <mat-form-field appearance="outline" class="w-100 mb-2">
        <mat-label>Password</mat-label>
        <input matInput [type]="hidePassword ? 'password' : 'text'" formControlName="password" placeholder="Password">
        <button mat-icon-button matSuffix type="button" (click)="hidePassword = !hidePassword">
          <mat-icon>
            {{ hidePassword ? 'visibility_off' : 'visibility' }}
          </mat-icon>
        </button>
        <mat-error>Password is Required!</mat-error>
      </mat-form-field>

      <div class="mb-4" style="text-align: right;">
        <button mat-raised-button color="primary" type="submit" [disabled]="loginForm.invalid">
          Login
        </button>
      </div>
      <div class="text-muted small" style="text-align: left;">
        <a class="login-forgot"><span (click)="openForgotPassword()"> Forgot password?</span></a><br />
        <span class="admin-login">Don't have an account? <a class="signlink" (click)="signup()"><span>Register
              here</span></a></span><br />
        <span class="terms" (click)="openTermsAndConditionDialog()">Terms of use</span> | <span class="terms"
          (click)="openPrivacyPolicyDialog()">Privacy policy</span>
      </div>
    </form>
  </mat-card>
</section>